module.exports = __webpack_public_path__ + "img/pos_chuyen_noi_bo.e22d4cba.png";